module.exports = __webpack_public_path__ + "static/img/a054.b7f514e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a054.jpg
// module id = 1MsL
// module chunks = 0